import INVENTORY_API_BASE_URL from "../../config/api";

import "./ReturninboundNew.css";
import Axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import swal from "sweetalert";
import alertify from "alertifyjs";

function ReturnInbound1() {
  const [data, setData] = useState([]);
  const [shelf, setshelf] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const barcodeInputRef = useRef(null);
  const [showSelectedTable, setShowSelectedTable] = useState(false);
  const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
  const [rowCheckboxSelected, setRowCheckboxSelected] = useState({});
  const [checkboxClickCount, setCheckboxClickCount] = useState(0);
  const [barcodeCount, setBarcodeCount] = useState(0);
  const [rowSums, setRowSums] = useState([]);
  const [sku, setsku] = useState([]);
  const [orderseq, setorderseq] = useState([]);
  const [title, setTitle] = useState([]);
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedShelfId, setSelectedShelfId] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [allowedBarcodeCount, setAllowedBarcodeCount] = useState(0);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const toggleRow = (orderSeq) => {
    setExpandedRows((prevExpanded) =>
      prevExpanded.includes(orderSeq)
        ? prevExpanded.filter((seq) => seq !== orderSeq)
        : [...prevExpanded, orderSeq]
    );
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setData(response.data);
      }
    );
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setshelf(response.data);
      }
    );
  }, []);

  const handleCheckboxChange = (event, SKU, OrderSeq, Title, GoodQty) => {
    const isChecked = event.target.checked;

    setsku(SKU);
    setorderseq(OrderSeq);
    setTitle(Title);

    if (isChecked) {
      setAllowedBarcodeCount(GoodQty);
      setBarcodeCount(0);
      setEnteredBarcodesList([]);
    }

    setRowCheckboxSelected((prev) => ({
      ...prev,
      [SKU]: isChecked,
    }));

    if (isChecked) {
      const matchingShelfEntries = shelf.filter((entry) => entry.sku === SKU);
      setSelectedRows(matchingShelfEntries);
      setShowSelectedTable(true);
    } else {
      setSelectedRows([]);
      setShowSelectedTable(false);
    }

    setIsCheckboxClicked(isChecked);
  };

  const handleBarcodeScanned = async (scannedBarcode) => {
    if (barcodeCount >= allowedBarcodeCount) {
      alertify.error(
        `Only ${allowedBarcodeCount} barcodes allowed as per Good Quantity`
      );
      setBarcode("");
      barcodeInputRef.current.focus();
      return;
    }

    if (!isCheckboxClicked) {
      swal({
        title: "Please select checkbox",
        icon: "error",
      });
      setBarcode("");
      return;
    }

      const selectedRow = selectedRows.find(
  (row) => row._id === selectedShelfId
);

if (!selectedRow) {
  alertify.error("Please Select Shelf");
  setBarcode("");
  barcodeInputRef.current.focus();
  return;
}

    try {
      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getKey/${scannedBarcode}`
      );
      const key = response.data.key;

      if (!key.includes(sku)) {
        alertify.error(`SKU ${sku} not found in the barcode.`);
        setBarcode("");
        barcodeInputRef.current.focus();
        return;
      }

      const isBarcodeInShelf = shelf.some((shelfItem) =>
        shelfItem.barcodeData.includes(key)
      );

      if (isBarcodeInShelf) {
        alertify.error("Barcode is already present in shelf.");
        setBarcode("");
        barcodeInputRef.current.focus();
        return;
      }

      if (enteredBarcodesList.includes(key)) {
        alertify.error("Barcode is already scanned here.");
        setBarcode("");
        barcodeInputRef.current.focus();
        return;
      }

      const updatedBarcodeList = [...enteredBarcodesList, key];
      const newBarcodeCount = barcodeCount + 1;
      setEnteredBarcodesList(updatedBarcodeList);
      setBarcodeCount(newBarcodeCount);
      setBarcode("");
      alertify.success(`Barcode ${key} added successfully.`);
      barcodeInputRef.current.focus();

      const selectedRow = selectedRows.find(
        (row) => row._id === selectedShelfId
      );
      if (!selectedRow) {
        alertify.error("Selected shelf not found.");
        return;
      }

      const sum = selectedRow.presentquantity + newBarcodeCount;
      const newemptyspace = selectedRow.emptyspace - newBarcodeCount;

      await Axios.put(`${INVENTORY_API_BASE_URL}/putaway`, {
        id: selectedRow._id,
        barcodeData: updatedBarcodeList,
        presentquantity: sum,
        emptyspace: newemptyspace,
      });

      await Axios.post(`${INVENTORY_API_BASE_URL}/scanReturnInbound`, {
        grnNo: orderseq,
        barcodeData: [key],
        count: 1,
        sku: sku,
        Title: title,
      });

    } catch (error) {
      console.error("Error during auto-save process:", error);
      alertify.error("Error saving barcode.");
    }
  };

  useEffect(() => {
    const calculatedSums = selectedRows.map(
      (row) => row.presentquantity + barcodeCount
    );
    setRowSums(calculatedSums);
    const handleClickOutside = (event) => {
      if (
        barcodeInputRef.current &&
        !barcodeInputRef.current.contains(event.target)
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, [selectedRows, barcodeCount]);

  const handleShelfCheckboxChange = (event, shelfId) => {
    const isChecked = event.target.checked;
    setSelectedShelfId(shelfId);
    setIsCheckboxClicked(true);
    barcodeInputRef.current.focus();
  };

  useEffect(() => {
    const filtered = data.filter(
      (row) =>
        row.OrderSeq?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        row.Distributor?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setTotalPages(Math.ceil(filtered.length / itemsPerPage));
    setCurrentPage(1);
  }, [data, itemsPerPage, searchTerm]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginate = (array, page_number, page_size) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const getPageRange = () => {
    const maxPagesToShow = 15;
    const middlePage = Math.ceil(maxPagesToShow / 2);
    let startPage = Math.max(currentPage - middlePage, 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    endPage = Math.min(endPage, totalPages);

    startPage = Math.max(endPage - maxPagesToShow + 1, 1);

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <main className="return-inbound-new-page">
      <div className="return-inbound-new-shell">
        <header className="return-inbound-new-hero">
          <div>
            <p className="return-inbound-new-eyebrow"><span aria-hidden="true" /> RETURNS / INBOUND PROCESSING</p>
            <h1>Return Inbound <span>(New)</span></h1>
            <p>Expand a return GRN, select the returned SKU, choose its shelf, and scan it into stock.</p>
          </div>
          <div className="return-inbound-new-badge">
            <span>SCAN MODE</span>
            <strong>Auto-save enabled</strong>
            <small>Each accepted barcode updates inventory immediately</small>
          </div>
        </header>

        <section className="return-inbound-new-metrics" aria-label="Inbound summary">
          <article className="return-inbound-new-metric">
            <span className="return-inbound-new-metric-icon return-inbound-new-metric-icon--blue" aria-hidden="true">GRN</span>
            <div><span>Return batches</span><strong>{data.length.toLocaleString()}</strong><small>Newest records are listed first</small></div>
          </article>
          <article className="return-inbound-new-metric">
            <span className="return-inbound-new-metric-icon return-inbound-new-metric-icon--green" aria-hidden="true">SCAN</span>
            <div><span>Barcodes scanned</span><strong>{barcodeCount.toLocaleString()} <em>/ {allowedBarcodeCount || 0}</em></strong><small>Allowed quantity follows good units</small></div>
          </article>
          <article className="return-inbound-new-metric">
            <span className="return-inbound-new-metric-icon return-inbound-new-metric-icon--violet" aria-hidden="true">PAGE</span>
            <div><span>Current page</span><strong>{totalPages === 0 ? 0 : currentPage} <em>/ {totalPages}</em></strong><small>{itemsPerPage} batches per page</small></div>
          </article>
        </section>

        <section className="return-inbound-new-card" aria-labelledby="return-inbound-new-batches-title">
          <div className="return-inbound-new-toolbar">
            <div>
              <h2 id="return-inbound-new-batches-title">Return batches</h2>
              <p>Search by GRN number or distributor, then expand a batch to view its SKUs.</p>
            </div>
            <label className="return-inbound-new-search">
              <span aria-hidden="true">⌕</span>
              <input
                type="text"
                placeholder="Search GRN number or distributor"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-label="Search by GRN number or distributor"
              />
            </label>
          </div>

          <div className="return-inbound-new-pagination-row">
            <div className="return-inbound-new-result-count">
              <span className="return-inbound-new-status-dot" aria-hidden="true" />
              {totalPages === 0 ? (
                <span>No return batches found</span>
              ) : (
                <span>Showing <strong>{(currentPage - 1) * itemsPerPage + 1}–{Math.min(currentPage * itemsPerPage, data.filter((row) =>
                  row.OrderSeq?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                  row.Distributor?.toLowerCase().includes(searchTerm.toLowerCase())
                ).length)}</strong> of <strong>{data.filter((row) =>
                  row.OrderSeq?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                  row.Distributor?.toLowerCase().includes(searchTerm.toLowerCase())
                ).length.toLocaleString()}</strong> batches</span>
              )}
            </div>
            <nav className="return-inbound-new-pagination" aria-label="Return batch pages">
              <button
                type="button"
                className="return-inbound-new-page-button"
                onClick={handlePreviousPage}
                disabled={currentPage === 1 || totalPages === 0}
              ><span aria-hidden="true">←</span> Previous</button>
              <div className="return-inbound-new-page-numbers">
                {getPageRange().map((pageNumber) => (
                  <button
                    type="button"
                    className={pageNumber === currentPage ? "return-inbound-new-page-number return-inbound-new-page-number--active" : "return-inbound-new-page-number"}
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    disabled={pageNumber === currentPage}
                    aria-current={pageNumber === currentPage ? "page" : undefined}
                  >{pageNumber}</button>
                ))}
              </div>
              <button
                type="button"
                className="return-inbound-new-page-button"
                onClick={handleNextPage}
                disabled={currentPage === totalPages || totalPages === 0}
              >Next <span aria-hidden="true">→</span></button>
            </nav>
          </div>

          {totalPages > 0 ? (
            <div className="return-inbound-new-table-wrap">
              <Table className="return-inbound-new-table">
                <thead>
                  <tr>
                    {["Select", "GRN No.", "Distributor", "SKU", "Title", "Edition", "Medium", "Return qty", "Good qty", "Bad qty", "Invoice no.", "Date"].map((header) => (
                      <th key={header} scope="col">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginate(
                    data.filter(
                      (row) =>
                        row.OrderSeq?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                        row.Distributor?.toLowerCase().includes(searchTerm.toLowerCase())
                    ),
                    currentPage,
                    itemsPerPage
                  ).map((row) => (
                    <React.Fragment key={row.OrderSeq}>
                      <tr className="return-inbound-new-batch-row">
                        <td colSpan={12}>
                          <button
                            type="button"
                            className="return-inbound-new-batch-toggle"
                            onClick={() => toggleRow(row.OrderSeq)}
                            aria-expanded={expandedRows.includes(row.OrderSeq)}
                          >
                            <span className="return-inbound-new-chevron" aria-hidden="true">{expandedRows.includes(row.OrderSeq) ? "⌄" : "›"}</span>
                            <span className="return-inbound-new-batch-details">
                              <strong>GRN {row.OrderSeq}</strong>
                              <span>{row.Distributor || "Distributor not listed"}</span>
                              <small>{row.Entries.length} item{row.Entries.length === 1 ? "" : "s"} <span aria-hidden="true">·</span> {formatDate(row.Date)}</small>
                            </span>
                            <span className="return-inbound-new-expand-label">{expandedRows.includes(row.OrderSeq) ? "Hide items" : "View items"}</span>
                          </button>
                        </td>
                      </tr>

                      {expandedRows.includes(row.OrderSeq) &&
                        row.Entries.map((entry, entryIndex) => (
                          <tr key={entryIndex} className="return-inbound-new-entry-row">
                            <td>
                              <input
                                className="return-inbound-new-checkbox"
                                type="checkbox"
                                onChange={(event) =>
                                  handleCheckboxChange(event, entry.SKU, row.OrderSeq, entry.Title, entry.Good_Quantity)
                                }
                                aria-label={"Select " + entry.SKU + " in GRN " + row.OrderSeq}
                              />
                            </td>
                            <td>{row.OrderSeq}</td>
                            <td>{row.Distributor}</td>
                            <td><span className="return-inbound-new-sku">{entry.SKU}</span></td>
                            <td className="return-inbound-new-title-cell" title={entry.Title}>{entry.Title}</td>
                            <td>{entry.Edition}</td>
                            <td>{entry.Medium}</td>
                            <td>{entry.Return_Quantity}</td>
                            <td><span className="return-inbound-new-good-qty">{entry.Good_Quantity}</span></td>
                            <td>{entry.Bad_Quantity}</td>
                            <td>{row.Invoice_Number}</td>
                            <td>{formatDate(row.Date)}</td>
                          </tr>
                        ))
                      }
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="return-inbound-new-empty">
              <span aria-hidden="true">⌕</span>
              <strong>No return batches match</strong>
              <p>Try another GRN number or distributor search.</p>
            </div>
          )}
        </section>

        {showSelectedTable && (
          <section className="return-inbound-new-card return-inbound-new-shelf-card" aria-labelledby="return-inbound-new-shelf-title">
            <div className="return-inbound-new-toolbar">
              <div>
                <p className="return-inbound-new-section-kicker">NEXT STEP / STORAGE</p>
                <h2 id="return-inbound-new-shelf-title">Choose a destination shelf</h2>
                <p>Select where this SKU’s returned books should be placed.</p>
              </div>
              <div className="return-inbound-new-selection-pill">{selectedRows.length.toLocaleString()} matching shelf{selectedRows.length === 1 ? "" : "s"}</div>
            </div>

            <div className="return-inbound-new-table-wrap return-inbound-new-shelf-wrap">
              <Table className="return-inbound-new-table return-inbound-new-shelf-table">
                <thead>
                  <tr>
                    {["Select shelf", "Warehouse", "Rack", "Shelf", "SKU", "Type", "Capacity", "Empty space", "Present qty", "Added qty", "Total qty"].map((header) => (
                      <th key={header} scope="col">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {selectedRows.map((row, index) => {
                    const sum = row.presentquantity + barcodeCount;
                    const newemptyspace = row.emptyspace - barcodeCount;
                    return (
                      <tr key={row._id || index}>
                        <td>
                          <input
                            className="return-inbound-new-checkbox"
                            type="checkbox"
                            onChange={(event) => handleShelfCheckboxChange(event, row._id)}
                            aria-label={"Select shelf " + row.shelfno + " in " + row.Warehouse}
                          />
                        </td>
                        {[
                          row.Warehouse,
                          row.rackno,
                          row.shelfno,
                          row.sku,
                          row.type,
                          row.capacity,
                          newemptyspace,
                          row.presentquantity,
                          barcodeCount,
                          sum,
                        ].map((cell, idx) => (
                          <td key={idx}>{cell}</td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <div className="return-inbound-new-scan-grid">
              <div className="return-inbound-new-scan-panel">
                <div className="return-inbound-new-scan-heading">
                  <span className="return-inbound-new-scan-icon" aria-hidden="true">⌁</span>
                  <div><h3>Scan returned barcodes</h3><p>Each accepted barcode is saved to the selected shelf automatically.</p></div>
                </div>
                <div className="return-inbound-new-capacity">
                  <div><span>Scanned</span><strong>{barcodeCount} <small>/ {allowedBarcodeCount}</small></strong></div>
                  <div className="return-inbound-new-progress" role="progressbar" aria-valuemin="0" aria-valuemax={allowedBarcodeCount} aria-valuenow={barcodeCount}>
                    <span style={{ width: (allowedBarcodeCount > 0 ? Math.min((barcodeCount / allowedBarcodeCount) * 100, 100) : 0) + "%" }} />
                  </div>
                  <small>Based on the selected item’s good quantity.</small>
                </div>
                <label className="return-inbound-new-field-label" htmlFor="return-inbound-new-barcode">Barcode</label>
                <div className="return-inbound-new-scan-control">
                  <input
                    id="return-inbound-new-barcode"
                    className="return-inbound-new-barcode-input"
                    type="text"
                    ref={barcodeInputRef}
                    value={barcode}
                    onChange={(e) => setBarcode(e.target.value)}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        handleBarcodeScanned(barcode);
                      }
                    }}
                    placeholder="Scan or type barcode"
                  />
                  <button
                    className="return-inbound-new-primary-button"
                    type="button"
                    onClick={() => handleBarcodeScanned(barcode)}
                  >Add manually <span aria-hidden="true">→</span></button>
                </div>
                <p className="return-inbound-new-helper">Selected SKU: <strong>{sku || "Choose an item above"}</strong></p>
              </div>

              <div className="return-inbound-new-scanned-panel">
                <div className="return-inbound-new-scan-heading">
                  <span className="return-inbound-new-scan-icon return-inbound-new-scan-icon--green" aria-hidden="true">✓</span>
                  <div><h3>Scanned barcodes</h3><p>{enteredBarcodesList.length.toLocaleString()} of {allowedBarcodeCount || 0} allowed</p></div>
                </div>
                {enteredBarcodesList.length > 0 ? (
                  <ul className="return-inbound-new-barcode-list">
                    {enteredBarcodesList.map((scanned, index) => (
                      <li key={scanned + index}><span aria-hidden="true">✓</span>{scanned}</li>
                    ))}
                  </ul>
                ) : (
                  <div className="return-inbound-new-barcode-empty">Your scanned barcodes will appear here.</div>
                )}
              </div>
            </div>
          </section>
        )}
      </div>
    </main>
  );

}

export default ReturnInbound1;
